<template>
    <div class="mb-5" :class="$widgetUI=='NEW-UI'? '':'flex flex-wrap md:flex-nowrap items-start justify-between mt-5'">
        <div class=" w-full md:w-auto order-2 md:order-1" :class="$widgetUI=='NEW-UI'? '':'flex items-start flex-wrap'" data-your-select>
            <strong class="mr-2 mt-2 " :class="$widgetUI=='NEW-UI'? 'block font text-[18px] mb-4':''">
                {{$widgetUI=='NEW-UI' ? 'Your filters': 'Your Selects'}}:
                <help-tip v-if="selectedData.audience.code == 'b2b'"
                          content="These are the filters that generated the samples below. Add additional Geography, Firmographic, and Contact Info filters to further customize your list."/>
                <help-tip v-else
                          content="These are the filters that generated the samples below. Add additional Geography, Demographic, and Contact Info filters to further customize your list."/>
            </strong>

            <div class="inline-block border cursor-pointer"
                 :class="[$widgetUI=='OLD-UI' && (selectsNotEmpty || subAudienceEmail) ? 'bg-yellow-100 hover:bg-green-100 rounded-xl py-1.5 px-3 mb-1 mr-1' :
                  $widgetUI=='NEW-UI'&& (selectsNotEmpty || subAudienceEmail)? 'bg-gray-50 text-primary rounded-md border-2 border-sky-600 hover:bg-green-100 py-1.5 px-4 mb-4 mr-4 selection-item': 'bg-white']"
                 v-if="!geoNotEmpty"
                 @click="showSelectPosition('geography')">
                Whole USA
            </div>

            <div class="inline-block border  relative hover:bg-green-100 cursor-pointer max-w-7xl"
                 :class="[$widgetUI=='OLD-UI' && (selectsNotEmpty || subAudienceEmail) ? 'rounded-xl bg-yellow-100 hover:bg-green-100 cursor-pointer py-1.5 px-3 mb-1 mr-1' :
                  $widgetUI=='NEW-UI'&& (selectsNotEmpty || subAudienceEmail)? 'bg-gray-50 rounded-md text-primary border-2 border-sky-600 py-1.5 px-4 mb-4 mr-4 selection-item cursor-pointer': 'bg-white']"
                 @click="showSelectPosition('sub-audience')">
                {{ selectedData.audience.title }}: {{ selectedData.subAudience.title }}
                <icon-close v-if="subAudienceEmail"
                            @click.native="removeAudienceEmail()"
                            :w="16"
                            :h="16"
                            class="cursor-pointer ml-2 inline-block right-[5px] top-[10px]"
                            color="text-primary"/>
            </div>

            <template v-if="(selectsNotEmpty || subAudienceEmail) && $widgetUI=='OLD-UI'">
                <template v-for="select in selectedData.selects">
                    <div
                        class="rounded-xl border py-1.5 px-3 bg-yellow-100 mb-1 mr-1 relative hover:bg-green-100 cursor-pointer"
                        :class="{'pr-[24px]': !checkSelectIfDefault(select)}"
                        :key="select.key"
                        @click="showSelectPosition(select)">
                        {{ select.title }}<span v-if="select.showMore">...</span>
                        <span v-if="select.showMore"
                              class="cursor-pointer text-primary font-semibold hover:underline ml-2"
                              @click="editSelect(select.code)">
                            EDIT
                        </span>
                        <icon-close @click.native="removeItem(select)"
                                    v-if="!checkSelectIfDefault(select)"
                                    :w="16"
                                    :h="16"
                                    class="cursor-pointer absolute right-[5px] top-[9px]"
                                    color="text-primary"/>
                    </div>
                </template>
            </template>
            <template v-if="(selectsNotEmpty || subAudienceEmail) && $widgetUI=='NEW-UI'">

                <template v-for="(select, index) in selectedData.selects">
                    <div v-if="index < showItme"
                         class="inline-block rounded-md  border-2 border-sky-600 py-1.5 px-4 bg-gray-50 text-primary border-blue mb-4 mr-4 relative hover:bg-green-100 cursor-pointer selection-item"
                         :class="{'pr-[24px]': !checkSelectIfDefault(select)}"
                         :key="select.key"
                         @click="showSelectPosition(select)">
                        {{ select.title }}<span v-if="select.showMore">...</span>
                        <span v-if="select.showMore"
                              class="cursor-pointer text-primary font-semibold hover:underline ml-2"
                              @click="editSelect(select.code)">
                            EDIT
                        </span>
                        <icon-close @click.native="removeItem(select)"
                                    v-if="!checkSelectIfDefault(select)"
                                    :w="16"
                                    :h="16"
                                    class="cursor-pointer absolute right-[5px] top-[9px]"
                                    color="text-primary"/>
                    </div>
                </template>

            </template>
            <div>
                <button v-if="selectedData.selects.length > 2 " class="btn btn-sm border-none text-blue-900 font-semibold hover:text-primary-hover mt-1"
                        @click="viewAll()">
                    {{showItme == 2 ? 'View all' : 'View less' }}
                </button>
                <button class="btn btn-sm border-none font-semibold hover:text-primary-hover mt-1"
                        v-if="selectsNotEmptyWithXPer || subAudienceEmail"
                        @click="clearAll">
                    Clear Filters
                </button>
            </div>
        </div>
        <div class="order-1 md:order-2 flex space-x-2 mb-2 md:mb-0 md:mt-2"  v-if="$widgetUI=='OLD-UI'">
            <save-list v-if="saveListOn"/>
            <share-list v-if="shareListOn"/>
            <prefill-list v-if="prefillListOn"/>
        </div>
        <div v-if="$widgetUI=='NEW-UI' && selectedData.audience.title =='People'" class="my-3" data-title="Want phone numbers?" data-intro='For access to consumer phone numbers, please call in for assistance.' data-step="4" data-position="bottom-middle" data-scroll-to=".People">
            <p class="text-orange-500 text-[14px] hidden md:flex People" v-if="selectedData.audience.title =='People'">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6" width="18px" class="mr-2">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z" />
                </svg>
                <span>Call <strong>(877) 440-3282</strong> for other types of data or to add consumer phone numbers.</span>
            </p>
            <p class="text-orange-500 text-[14px] md:hidden flex" v-if="selectedData.audience.title =='People'">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6" width="18px" class="mr-2">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z" />
                </svg>
                <span> Call <strong>(877) 440-3282</strong> for other types of data or to add consumer phone numbers.</span>
            </p>

        </div>
    </div>
</template>

<script>
import { EventBus } from "@widget/plugins/event-bus";
import xPerSelectionMixin from "../mixins/xPerSelection";

export default {
    name: "your-selects",
    components: {
        ShareList: () => import("@widget/modules/share-list/share-list"),
        SaveList: () => import("@widget/modules/saved-lists/save-list"),
        PrefillList: () => import("@widget/modules/prefill-list/prefill-list")
    },
    data(){
        return{
            showItme:2
        }
    },
    props: {
        mobile: {
            type: Boolean,
            default: false
        }
    },
    mixins: [
        xPerSelectionMixin
    ],
    computed: {
        selectedData () {
            let selects = this.$store.getters["widgetData/getSelectedDataForUI"].selects
            this.showItme =  this.showItme > 2 ? selects.length : 2

            return this.$store.getters["widgetData/getSelectedDataForUI"];
        },
        selectsNotEmpty () {
            return this.selectedData.selects.length;
        },
        selectsNotEmptyWithXPer () {
            return this.selectedData.selects.filter(item => !item.code.includes("one_per_address")).length;
        },
        geoNotEmpty () {
            return this.selectedData.selects.find(item => item.code.includes("_geo_search") || item.code.includes("_zip_radius") || item.code.includes("_mapping"));
        },
        subAudienceEmail () {
            return this.selectedData.subAudience.code.includes("_email");
        },
        subAudiences() {
            return this.$store.getters["widgetData/getAudienceChildren"];
        },
        saveListOn() {
            return this.$widgetConfig.save_list;
        },
        shareListOn() {
            return this.$widgetConfig.share_list;
        },
        prefillListOn() {
            return this.$widgetConfig.prefill_btn;
        },
        xPerSelection() {
            return this.$store.getters["widgetData/getXPerSelection"];
        }
    },
    methods: {
        viewAll() {
            console.log(this.showItme);
            if (this.showItme == 2) {
                this.showItme = this.selectedData.selects.length;
            } else {
                this.showItme = 2
            }

        },
        checkSelectIfDefault(select) {
            return select.code.includes("one_per_address");
        },

        clearAll() {
            this.$store.commit("widgetData/clearAll");
            EventBus.$emit("clear-all");
            this.checkXPerSelection();
        },
        removeItem(item) {
            if (item.code.includes("_geo_search") || item.code.includes("_zip_radius") || item.code.includes("_mapping")) {
                this.$store.commit("widgetData/removeSelectGeo", item);
            } else {
                this.$store.commit("widgetData/removeSelect", item.code);
            }

            if (item.code.includes("_mapping")) {
                EventBus.$emit("remove-polygon", item.query);
            } else {
                EventBus.$emit("remove-select", item.code);
            }
        },
        removeAudienceEmail() {
            let subAudienceNew = this.subAudiences.find(item => item.code !== this.selectedData.subAudience);
            this.$store.commit("widgetData/setSubAudience", subAudienceNew.code);
        },
        editSelect(code) {
            EventBus.$emit("edit-select", code);
        },
        showSelectPosition(select) {
            EventBus.$emit("show-select-position", select);
        }
    }
};
</script>
